<template>
  <div>
    Please wait...
  </div>
</template>

<script>
export default {
  name: 'CallbackMs',
  props: {
    successRoute: {
      type: Object,
      required: true,
    },
    errorRoute: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timer: null,
    }
  },
  mounted() {
    console.log('callbackms mounted')

    this.timer = setInterval(this.checkAuth, 1000)
  },
  methods:
  {
    checkAuth()
    {
      var error = JSON.parse(window.localStorage.getItem('auth.mserror'))

      if(error)
      {
        clearInterval(this.timer)

        // we have processing!

        console.log('callbackms detected response...')

        if(error === 'success')
        {
          console.log('callbackms detected success!')
          this.$store.commit('auth/SET_AUTH', JSON.parse(window.localStorage.getItem('auth.identity')))

          let _returnUrl = JSON.parse(window.localStorage.getItem('returnUrl'))

          if (_returnUrl && _returnUrl !== '') {
              window.localStorage.setItem('returnUrl', JSON.stringify(''))
              this.$router.push({
                name: _returnUrl.name,
                params: _returnUrl.params,
              })
            } else this.$router.push(this.successRoute)
          }
        else
        {
          console.log('callback ms detected failure: ' + error)
          this.$router.push(this.errorRoute)
        }
      }
      else{
        console.log('callbackms detected no response yet...')
      }


      // window.localStorage.setItem('callbackms', 'mounted...')

      // var error = JSON.parse(window.localStorage.getItem('auth.mserror'))

      // if(error && error.errorCode)
      // {
      //   window.localStorage.setItem('callbackms', 'error:' + error.errorMessage)
      //   console.log(error.errorMessage)
      //   this.$router.push(this.errorRoute)
      // }
      // else
      // {
      //   window.localStorage.setItem('callbackms', 'success')
      //   console.log('ms success')

      //   this.$store.commit('auth/SET_AUTH', JSON.parse(window.localStorage.getItem('auth.identity')))

      //   let _returnUrl = JSON.parse(window.localStorage.getItem('returnUrl'))

      //   if (_returnUrl && _returnUrl !== '') {
      //     window.localStorage.setItem('returnUrl', JSON.stringify(''))
      //     this.$router.push({
      //       name: _returnUrl.name,
      //       params: _returnUrl.params,
      //     })
      //   } else this.$router.push(this.successRoute)
      // }
    },
  }
}
</script>
